<template>
  <div class="col-12">
    <a
      v-if="dataProvided"
      :href="auctionsCatalogRoute"
      class="auction_house-banner">
      <span class="auction_house-banner__short-name">
        {{ auctionsCatalog.auctionHouseShortName }}
      </span>
      <span class="auction_house-banner__date">
        <span>
          {{I18n.l("time.formats.full_date", auctionsCatalog.startDate) }}
        </span>
        <span class="icon icon-calendar ml-1"></span>
      </span>
    </a>
  </div>
</template>

<script>
  /* global Routes */

  export default {
    name: 'AuctionHouseName',
    props: {
      auctionsCatalog: {
        type: Object,
        required: true,
      },
    },
    computed: {
      dataProvided() {
        const hasOwnProperty = Object.prototype.hasOwnProperty;
        return hasOwnProperty.call(this.auctionsCatalog, 'startDate') &&
               hasOwnProperty.call(this.auctionsCatalog, 'auctionHouseShortName');
      },
      auctionsCatalogRoute() {
        return Routes.auctions_catalog_path(this.auctionsCatalog.slug);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/auction_house_name.vue?8182cc10